import React from "react";
import { IconButton, Stack } from "@fluentui/react";
import { useAppDispatch } from "../../hooks/redux";
import { setPreviousPageURLAction } from "../../store/actions/utilityActions";
import { useLocation, useNavigate } from "react-router-dom";
import "./index.css";
import { ROUTES } from "../../config/routes";

interface SubHeaderProps {
  title: string;
  showBackButton?: boolean;
  backPageURL?: string;
  actionOnBackButton?: () => void;
  filter?: React.ReactNode;
  height?: number;
}

const SubHeader: React.FC<SubHeaderProps> = (props) => {
  const { title, showBackButton, backPageURL, actionOnBackButton, filter, height } = props;
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const backButtonHandler = () => {
    dispatch(setPreviousPageURLAction(location.pathname));

    if (actionOnBackButton) {
      actionOnBackButton();
      return;
    }

    if (window.history.length <= 2) {
      navigate(backPageURL ?? ROUTES["home"].url, { replace: true });
    } else {
      navigate(-1);
    }
  };

  return (
    <div
      className="subheader-container"
      style={height ? { height, boxSizing: "border-box" } : undefined}
    >
      <Stack
        horizontal
        verticalAlign="center"
        tokens={{ childrenGap: 10 }}
        styles={height ? { root: { height: "100%" } } : undefined}
      >
        {showBackButton && (
          <Stack.Item align="center">
            <IconButton
              iconProps={{ iconName: "ChromeBack" }}
              title="Back"
              ariaLabel="Back"
              onClick={backButtonHandler}
            />
          </Stack.Item>
        )}
        <Stack.Item align="center" grow={10}>
          <span className="subheader-title">{title}</span>
        </Stack.Item>
        {filter && (
          <Stack.Item grow={1}>
            {filter}
          </Stack.Item>
        )}
      </Stack>
    </div>
  );
};

export default SubHeader;
